<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-toolbar color="#313a46">
        <v-card-title class="text-h5 white--text">
          {{ labelBtn }} Grupo
        </v-card-title>
      </v-toolbar>

      <v-card-text>
        <v-container>
          <v-form ref="formGroups">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  :value="itensFormGroups.nome"
                  @input="
                    ($event) => (itensFormGroups.nome = $event?.toUpperCase())
                  "
                  label="Nome do grupo"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :value="itensFormGroups.descricao"
                  @input="
                    ($event) =>
                      (itensFormGroups.descricao = $event?.toUpperCase())
                  "
                  label="Descrição"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          class="white--text btn-form"
          color="error"
          @click="closeModal()"
        >
          FECHAR
        </v-btn>
        <v-btn
          class="white--text mr-5 btn-form"
          :color="labelBtn == 'Cadastrar' ? '#313a46' : 'warning'"
          @click="labelBtn == 'Cadastrar' ? createGroup() : updateGroup()"
        >
          {{ labelBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import toast from "@/commom/toast";
import gruposEmail from "@/services/http/rpa/GruposEmail";
export default {
  props: {
    labelBtn: {
      type: String,
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    selectedItem: {},
  },
  data: () => ({
    itensFormGroups: {
      nome: "",
      descricao: "",
    },
    itensFormContributors: {
      colaborador_id: "",
    },
    rules: {
      required: (value) => !!value || "Campo obrigatório.",
    },
  }),
  created() {},
  methods: {
    async closeModal() {
      this.$emit("update:dialog", false);
      // await this.$parent.fetchEmailGroups();
    },
    async createGroup() {
      if (this.$refs.formGroups.validate()) {
        await gruposEmail()
          .store(this.itensFormGroups)
          .then((res) => {
            this.$swal({
              title: "Grupo cadastrado!",
              text: "Deseja adicionar colaboradores a esse grupo?",
              icon: "success",
              showDenyButton: true,
              confirmButtonText: "Sim!",
              denyButtonText: "Não, obrigado",
            }).then((result) => {
              if (result.isConfirmed) {
                this.$parent.openModalAdd(res.data);
              }
              this.closeModal();
            });
          })

          .catch((err) => {
            console.log(err);
          });
      }
    },

    async updateGroup() {
      if (!this.$refs.formGroups.validate()) return;
      try {
        await gruposEmail(this.selectedItem.id).update(this.itensFormGroups);
        toast("success", "Grupo alterado!");
        this.closeModal();
      } catch (error) {
        toast("error", "Algo deu errado...");
      }
    },
    async deleteGroup() {
      await gruposEmail(this.selectedItem.id).delete();
    },
  },
  watch: {
    async selectedItem(item) {
      this.itensFormGroups = item;
    },
  },
};
</script>
